export default "__VITE_ASSET__C2AmbbZ2__"